import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import submit from "submit-form";
import { getLoadAndUnit } from "../../../../utils/converters/convert-units";
import SvgIcon from "../../../SvgIcon";

// Read-only row for an existing Personal Record goal, in Periodization's
// manage-milestone-goals modal (see
// ~/.claude/plans/periodization-add-goal-modal.md Fase 5). The visibility
// checkbox submits immediately on click (toggle-milestone-visibility, see
// client-goals.js) - independent from PersonalRecordInlineForm's own
// immediate-submit, since this row never enters edit mode itself (onEdit
// swaps it out for that other component instead).
export const PersonalRecordRow = ({ goal, units, query, t, onEdit }) => {
  // Same "{{reps}} reps @ {{load}} {{unit}}" format as Dashboard's
  // ClientGoals.js (its own DisplayGoalLabel) - not milestoneValueDetail's
  // "(load×reps)", which is the Calendar grid's own convention instead.
  const { value: loadValue, unit } = getLoadAndUnit(
    goal.details.targetLoad,
    units
  );
  const detail = t("annualPlanner.personalRecordDetail", {
    reps: goal.details.targetReps,
    load: loadValue,
    unit,
  });
  const isVisible = !goal.hiddenFromPlanner;

  const toggleVisibility = () => {
    submit(
      `/actions/client-goals/toggle-milestone-visibility/${goal._id}?proxyAthlete=${query.athlete}`,
      { method: "POST", body: { hiddenFromPlanner: isVisible } }
    );
  };

  return (
    <div className="goal-row personal-record-row">
      <div role="checkbox-wrapper" onClick={toggleVisibility}>
        <SvgIcon
          src={
            isVisible
              ? "/img/new-icons/checked-square.svg"
              : "/img/new-icons/unchecked-square.svg"
          }
        />
      </div>
      <div className="goal-row-info">
        <span className="goal-name">{goal.details.targetName}</span>
        {detail && <span className="goal-detail">{detail}</span>}
      </div>
      <span className="goal-date">
        {moment(String(goal.utcTargetDate), "YYYYMMDD").format("D MMM, YYYY")}
      </span>
      <button type="button" className="goal-edit-pencil" onClick={onEdit}>
        <SvgIcon src="/img/new-icons/edit-pencil.svg" />
      </button>
    </div>
  );
};

PersonalRecordRow.propTypes = {
  goal: PropTypes.object.isRequired,
  units: PropTypes.string,
  query: PropTypes.object,
  t: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};
